<template>
  <div class="km-module">
    <ul
      class="list-unstyled d-flex justify-content-between align-items-center stepper-list"
    >
      <li
        v-for="idx in stepTotal"
        :key="idx"
        class="position-relative d-flex flex-column align-items-center gap-2 stepper-list-item"
        :class="[step > idx ? 'activated' : '', step === idx ? 'active' : '']"
      >
        <div
          class="text-center user-select-none rounded-circle stepper-list-item-counter"
        >
          {{ idx }}
        </div>
        <small class="stepper-list-item-text">step-{{ idx }}</small>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'Steppers',
  props: {
    stepTotal: {
      type: Number,
      default: 3
    },
    step: {
      type: Number,
      default: 1
    }
  }
})
</script>
